<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Grower" | tenantWords}} Receipts</h2>
      <span class="page-subtitle">Received bins by {{"grower" | tenantWords}}, lot, and ticket</span>
    </div>
    <div class="header-actions">
      <button mat-stroked-button class="header-btn" (click)="exportExcel()" [disabled]="this.isLoading || !this.rows.length">
        <fa-icon [icon]="faFileExcel" class="me-2"></fa-icon>Export
      </button>
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="onSyncReceipts()" [disabled]="this.isLoading">
        <fa-icon [icon]="faSync" class="me-2"></fa-icon>Sync Receipts
      </button>
    </div>
  </div>

  <div class="filters-bar" [nbSpinner]="this.isFiltersLoading">
    <mat-form-field appearance="outline" class="filter-select" subscriptSizing="dynamic">
      <mat-select [(ngModel)]="selectedYear" placeholder="Crop Year" aria-label="Crop year">
        <mat-option *ngFor="let year of this.cropYears" [value]="year">{{year}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-select commodity-select" subscriptSizing="dynamic">
      <mat-select [(ngModel)]="selectedNames" multiple placeholder="All {{'commodities' | tenantWords}}" aria-label="Commodities">
        <mat-option *ngFor="let name of this.commodityNames" [value]="name">{{name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" class="filter-btn generate-btn" (click)="generateReport()" [disabled]="this.isLoading">
      Generate Report
    </button>

    <div class="search-box" *ngIf="this.hasReport">
      <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
      <input type="text" placeholder="Search by {{'grower' | tenantWords}}, variety, lot, ticket, or BOL..."
        [(ngModel)]="searchTerm" (ngModelChange)="applySearch()" class="search-input" aria-label="Search grower receipts">
    </div>
    <button mat-stroked-button type="button" class="clear-btn" *ngIf="this.hasReport" (click)="clearFilters()"
      [disabled]="!this.filterCount && !this.searchTerm">
      <fa-icon [icon]="faBan" class="me-2"></fa-icon>Clear Filters
      <span class="count-pill" *ngIf="this.filterCount">{{this.filterCount}}</span>
    </button>
  </div>

  <div class="kw-empty-card" *ngIf="!this.hasReport && !this.isLoading">
    <fa-icon [icon]="faReceipt" class="empty-icon"></fa-icon>
    <div class="empty-title">No report yet</div>
    <div>Pick a crop year and {{"commodities" | tenantWords}}, then generate the report.</div>
  </div>

  <div class="grid-card static" *ngIf="this.hasReport">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.rows" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings"
      [allowGrouping]="true" [groupSettings]="this.groupSettings"
      [enableStickyHeader]="true" [enableHover]="true" [allowExcelExport]="true"
      [aggregates]="this.aggregates"
      (excelAggregateQueryCellInfo)="aggregateQueryCellInfo($event)"
      (actionComplete)="onActionComplete($event)" (dataBound)="onGridDataBound()">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list" *ngIf="this.hasReport">
    <div class="m-card static" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow">
      <div class="m-card-top">
        <span class="m-card-name">{{row.GROWER || '—'}}</span>
        <span class="type-pill">{{row.RECEIVED_QUANTITY | number}} bins</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="row.Variety || row.ITEM_DESCRIPTION">
          <fa-icon [icon]="faTractor" class="m-meta-icon"></fa-icon>{{row.Variety}}<ng-container *ngIf="row.Variety && row.ITEM_DESCRIPTION"> · </ng-container>{{row.ITEM_DESCRIPTION}}
        </div>
        <div class="m-meta-line">
          <fa-icon [icon]="faReceipt" class="m-meta-icon"></fa-icon>{{"Lot" | tenantWords}} {{row.LOT_NUMBER || '—'}}<ng-container *ngIf="row.RECEIVING_TICKET_NBR"> · Ticket {{row.RECEIVING_TICKET_NBR}}</ng-container>
        </div>
        <div class="m-meta-line" *ngIf="row.HAULED_BY || row.BOL">
          <fa-icon [icon]="faTruck" class="m-meta-icon"></fa-icon>{{row.HAULED_BY}}<ng-container *ngIf="row.HAULED_BY && row.BOL"> · </ng-container><ng-container *ngIf="row.BOL">BOL {{row.BOL}}</ng-container>
        </div>
        <div class="m-meta-line" *ngIf="row.dateReceived">
          <fa-icon [icon]="faCalendar" class="m-meta-icon"></fa-icon>Received {{row.dateReceived | date:'M/d/y'}}<ng-container *ngIf="row.RECEIVING_LOCATION_NAME"> · {{row.RECEIVING_LOCATION_NAME}}</ng-container>
        </div>
      </div>

      <div class="m-card-foot" *ngIf="row.POOL_CODE || row.TREATMENT || row.BIN_TYPE">
        <span class="type-pill" *ngIf="row.POOL_CODE">Pool {{row.POOL_CODE}}</span>
        <span class="type-pill" *ngIf="row.TREATMENT">{{row.TREATMENT}}</span>
        <span class="type-pill" *ngIf="row.BIN_TYPE">{{row.BIN_TYPE}}</span>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faReceipt" class="m-empty-icon"></fa-icon>
      <div>No receipts match your search</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>
